import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=6ad0cd3d&scoped=true"
import script from "./TagView.vue?vue&type=script&lang=js"
export * from "./TagView.vue?vue&type=script&lang=js"
import style0 from "./TagView.vue?vue&type=style&index=0&id=6ad0cd3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad0cd3d",
  null
  
)

export default component.exports